import { createSessionStore } from '../util/session_store';
export const cachedResults = createSessionStore('cached_results', null);
